import Gauge from 'd3vue/components/GaugeMeter.vue'
import { toArray } from '../colors'
import { valueAsNumber } from '../dataFilter'
import api from '../api'

export default {
  id: 'gauge',
  label: 'Jauge',
  component: Gauge,
  dimensions: 0,
  multipleMeasure: () => false,
  adaptater: (data, vue) => {
    const value = valueAsNumber(data[0][api.measure.name(vue.measure[0])])
    const max = Math.max(value, 100)
    const props = {
      value,
      max: max,
      fontRatio: 0.09
    }
    if (vue.colorScheme) {
      props.colors = toArray(vue.colorScheme)
    }
    vue.buildProps(props)
    return []
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/Gauge.js